
import './Bumpups.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faPalette, faThumbsUp} from '@fortawesome/free-solid-svg-icons';

function Bumpups() {
  const cards = [
    { title: 'Fast', description: 'Responsive layout', icon: faRocket },
    { title: 'Modern', description: 'Clean UI styling', icon: faPalette },
    { title: 'Easy', description: 'Simple React setup', icon: faThumbsUp },
  ];

  return (
    <section className="bumpups" id="features">
      <h2>Quick Highlights</h2>
      <div className="bumpups__cards">
        {cards.map((card) => (
          <div key={card.title} className="bumpups__card">
            <div className="bumpups__cardHeading">
              <FontAwesomeIcon icon={card.icon} className="bumpups__icon" />
              <strong>{card.title}</strong>
            </div>
            <span>{card.description}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Bumpups;
